/*
  Keep words in headings whole. The theme lets section content break
  anywhere (word-break: break-word), which splits long words such as
  "Customer" or "Interchangeable" mid-word on narrow screens.
  valoi-tokens.css turns that off for headings; this script then shrinks
  a heading's font size just enough when its longest word is still wider
  than the heading itself.
*/
(() => {
  const SELECTOR = 'h1, h2, h3, h4, h5, h6, .kt-heading';
  const MIN_SCALE = 0.5;

  const longestWordWidth = (el) => {
    let widest = 0;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    let node;
    while ((node = walker.nextNode())) {
      // Lines may still break after a hyphen, so measure "CS-" and "LITE" separately.
      const words = node.textContent.matchAll(/[^\s-]+-?/g);
      for (const word of words) {
        range.setStart(node, word.index);
        range.setEnd(node, word.index + word[0].length);
        widest = Math.max(widest, range.getBoundingClientRect().width);
      }
    }
    return widest;
  };

  const fit = (el) => {
    const available = el.clientWidth;
    if (!available || available === el.valoiFitWidth) return;
    el.valoiFitWidth = available;

    el.style.removeProperty('font-size');
    const widest = longestWordWidth(el);
    // clientWidth is rounded, so allow a pixel of slack for shrink-wrapped headings.
    if (widest <= available + 1) return;

    const size = parseFloat(getComputedStyle(el).fontSize);
    const scale = Math.max(available / widest, MIN_SCALE);
    el.style.fontSize = `${Math.floor(size * scale * 10) / 10}px`;
  };

  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => fit(entry.target));
  });

  const observeAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => observer.observe(el));
  };

  const refitAll = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      el.valoiFitWidth = 0;
      fit(el);
    });
  };

  observeAll();
  // Web fonts change word widths, so measure again once they are in.
  document.fonts.ready.then(refitAll);
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
})();
